export interface GossipCard {
  id: string;
  title: string;
  category: string;
  tag: string;
  heat: number;
  date: string;
  excerpt: string;
  image: string;
  read: string;
}

export const categoryTabs = [
  { key: "all", label: "全部吃瓜" },
  { key: "yan", label: "影视圈" },
  { key: "zong", label: "综艺现场" },
  { key: "yu", label: "音乐与潮流" },
  { key: "shang", label: "商界风云" },
  { key: "sport", label: "体坛八卦" },
  { key: "net", label: "网络圈" },
];

export const hotList = [
  { rank: 1, title: "顶流演员片约风波：合同细节被逐条公开", heat: 986, up: true, category: "影视圈" },
  { rank: 2, title: "爆款综艺导师退赛内幕 20 条时间线整理", heat: 941, up: true, category: "综艺现场" },
  { rank: 3, title: "音乐节主办方与艺人团队隔空互怼全记录", heat: 903, up: true, category: "音乐与潮流" },
  { rank: 4, title: "新消费品牌联名翻车：从预热到滑跪全过程", heat: 877, up: true, category: "商界风云" },
  { rank: 5, title: "顶流运动员经纪人换人风波背后人物关系图", heat: 832, up: false, category: "体坛八卦" },
  { rank: 6, title: "头部主播直播翻车：网友考古发现早期言论", heat: 798, up: false, category: "网络圈" },
  { rank: 7, title: "剧集番位海报事件：粉丝互撕始末复盘", heat: 764, up: true, category: "影视圈" },
  { rank: 8, title: "选秀节目票数质疑：主办方回应后舆论反转", heat: 731, up: true, category: "综艺现场" },
  { rank: 9, title: "大厂高管离职创业：前东家点赞评论区引热议", heat: 688, up: false, category: "网络圈" },
  { rank: 10, title: "歌手版权之争：翻唱授权的边界在哪里", heat: 651, up: false, category: "音乐与潮流" },
];

export const trending = [
  { title: "剧集番位海报事件", tag: "爆", delta: "+18" },
  { title: "导师退赛内幕", tag: "热", delta: "+9" },
  { title: "联名滑跪事件", tag: "沸", delta: "+26" },
  { title: "选秀票数质疑", tag: "新", delta: "+5" },
];

export const gossips: GossipCard[] = [
  {
    id: "g1",
    title: "顶流演员片约风波完整存档：合同细节如何被逐条公开",
    category: "影视圈",
    tag: "深度",
    heat: 986,
    date: "2026.09.04",
    read: "12 分钟",
    excerpt:
      "从营销号首曝、片方声明到工作室回应，我们按时间顺序梳理了这场波及投资方、平台与粉丝的片约争议，把散落在各处的信源一次性归档。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20red%20curtain%20backstage%20film%20set%20with%20warm%20spotlights%20and%20scattered%20script%20pages%2C%20editorial%20dramatic%20lighting%2C%20abstract%20moody%20atmosphere&width=800&height=520&seq=g1&orientation=landscape",
  },
  {
    id: "g2",
    title: "爆款综艺导师退赛内幕 20 条时间线一次理清",
    category: "综艺现场",
    tag: "存档",
    heat: 941,
    date: "2026.09.03",
    read: "10 分钟",
    excerpt:
      "从录制现场流出的片场照，到节目组发布声明，再到多方信源交叉印证。我们用一条时间线把导师退赛前后的关键节点全部串起来，供想一次吃透的观众查阅。",
    image:
      "https://readdy.ai/api/search-image?query=glowing%20stage%20lights%20and%20audio%20console%20backstage%20of%20variety%20show%2C%20warm%20amber%20and%20teal%20editorial%20mood%20lighting%2C%20abstract%20cinematic&width=800&height=520&seq=g2&orientation=landscape",
  },
  {
    id: "g3",
    title: "音乐节主办方与艺人团队隔空互怼全记录",
    category: "音乐与潮流",
    tag: "深度",
    heat: 903,
    date: "2026.09.02",
    read: "9 分钟",
    excerpt:
      "一场延期引发的口水战：谁先违约、为何互发声明、现场为何缺人？我们把双方口径、网友观点与行业惯例放在同一视角里，尽量还原事情全貌。",
    image:
      "https://readdy.ai/api/search-image?query=music%20festival%20stage%20with%20crowd%20silhouettes%20under%20golden%20hour%20lights%20and%20confetti%2C%20warm%20vibrant%20editorial%20concert%20atmosphere&width=800&height=520&seq=g3&orientation=landscape",
  },
  {
    id: "g4",
    title: "新消费品牌联名翻车：从预热到滑跪全过程复盘",
    category: "商界风云",
    tag: "热门",
    heat: 877,
    date: "2026.09.01",
    read: "11 分钟",
    excerpt:
      "联名官宣、网友考古、连夜致歉、后续补救……一次典型的品牌舆情案例。我们整理了整条反应链，看一个品牌如何用三天时间从爆火走向紧急公关。",
    image:
      "https://readdy.ai/api/search-image?query=minimalist%20product%20packaging%20boxes%20on%20cream%20backdrop%20with%20warm%20studio%20lighting%20and%20copywriting%20sketches%2C%20editorial%20branding%20concept%20abstract&width=800&height=520&seq=g4&orientation=landscape",
  },
  {
    id: "g5",
    title: "顶流运动员经纪人换人风波：人物关系图全解",
    category: "体坛八卦",
    tag: "整理",
    heat: 832,
    date: "2026.08.31",
    read: "8 分钟",
    excerpt:
      "从老经纪深夜发文、新团队入场，到俱乐部与商业代言的表态，一场换帅背后牵出多条利益线。我们用可视化关系图帮你理清各方立场。",
    image:
      "https://readdy.ai/api/search-image?query=stadium%20track%20lane%20at%20dusk%20with%20warm%20rim%20lighting%20and%20abstract%20motion%20blur%2C%20editorial%20sports%20moody%20cinematic&width=800&height=520&seq=g5&orientation=landscape",
  },
  {
    id: "g6",
    title: "头部主播直播翻车：网友考古发现早期言论",
    category: "网络圈",
    tag: "考古",
    heat: 798,
    date: "2026.08.29",
    read: "10 分钟",
    excerpt:
      "一次口误被无限放大后，网友开始倒带回看主播往期直播切片。我们汇总了被反复讨论的关键片段与其前后语境，尽量还原完整信息而非断章取义。",
    image:
      "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20desk%20with%20ring%20light%20and%20monitors%20in%20warm%20evening%20tones%2C%20editorial%20behind%20the%20scenes%20abstract&width=800&height=520&seq=g6&orientation=landscape",
  },
  {
    id: "g7",
    title: "剧集番位海报事件：粉丝互撕始末复盘",
    category: "影视圈",
    tag: "复盘",
    heat: 764,
    date: "2026.08.27",
    read: "7 分钟",
    excerpt:
      "一张海报、两套番位说法、三份数据榜单。我们把这场持续数日的粉丝舆论战按时间梳理，并附上片方与主演团队各自的解释口径。",
    image:
      "https://readdy.ai/api/search-image?query=film%20poster%20wall%20in%20dark%20theater%20lobby%20with%20warm%20accent%20glow%2C%20editorial%20cinematic%20abstract%20composition&width=800&height=520&seq=g7&orientation=landscape",
  },
  {
    id: "g8",
    title: "选秀节目票数质疑：主办方回应后舆论如何反转",
    category: "综艺现场",
    tag: "深度",
    heat: 731,
    date: "2026.08.25",
    read: "12 分钟",
    excerpt:
      "票数异常、数据打假、主办方晒后台、第三方机构进场……我们完整记录了质疑从发酵到被澄清的每一个阶段，是理解票数之争的一份完整样本。",
    image:
      "https://readdy.ai/api/search-image?query=voting%20screen%20and%20studio%20audience%20silhouette%20with%20warm%20stage%20glow%2C%20editorial%20variety%20show%20atmosphere%20abstract&width=800&height=520&seq=g8&orientation=landscape",
  },
  {
    id: "g9",
    title: "大厂高管离职创业：前东家点赞评论区引发热议",
    category: "网络圈",
    tag: "热门",
    heat: 688,
    date: "2026.08.22",
    read: "8 分钟",
    excerpt:
      "一条离职朋友圈、前老板一个轻描淡写的点赞，就能搅动职场与互联网圈的热议。我们把来龙去脉、各方解读与职场人的真实讨论一并存档。",
    image:
      "https://readdy.ai/api/search-image?query=modern%20glass%20office%20at%20sunset%20with%20warm%20interior%20light%20and%20abstract%20reflection%2C%20editorial%20corporate%20minimal%20style&width=800&height=520&seq=g9&orientation=landscape",
  },
  {
    id: "g10",
    title: "歌手版权之争：翻唱授权的边界到底在哪里",
    category: "音乐与潮流",
    tag: "科普",
    heat: 651,
    date: "2026.08.20",
    read: "9 分钟",
    excerpt:
      "当翻唱致敬撞上版权主张，规则边界往往模糊。我们从改编权、表演权到平台授权层层拆解，用通俗语言讲清这场音乐圈版权争议。",
    image:
      "https://readdy.ai/api/search-image?query=vinyl%20records%20and%20headphones%20on%20warm%20desk%20with%20sheet%20music%2C%20editorial%20warm%20cozy%20music%20abstract&width=800&height=520&seq=g10&orientation=landscape",
  },
  {
    id: "g11",
    title: "电竞选手转会费传闻：报价单截图是真是假",
    category: "体坛八卦",
    tag: "深扒",
    heat: 619,
    date: "2026.08.18",
    read: "10 分钟",
    excerpt:
      "一张模糊的报价单截图在粉丝群疯传，随后被多方否认。我们追查了截图信源、俱乐部回应与知情人士说法，梳理这场转会传闻的可信度。",
    image:
      "https://readdy.ai/api/search-image?query=esports%20gaming%20keyboard%20with%20warm%20neon%20ambient%20glow%20on%20dark%20desk%2C%20editorial%20tech%20abstract%20accent%20lighting&width=800&height=520&seq=g11&orientation=landscape",
  },
  {
    id: "g12",
    title: "翻唱节目选手被扒旧照：人设争议还原年代语境",
    category: "音乐与潮流",
    tag: "讨论",
    heat: 597,
    date: "2026.08.16",
    read: "8 分钟",
    excerpt:
      "旧照曝光后，一边是人设崩塌的声讨，一边是断章取义的反驳。我们尽量还原旧照年代与语境，呈现这场身份争议的多个侧面。",
    image:
      "https://readdy.ai/api/search-image?query=retro%20photo%20albums%20and%20polaroid%20prints%20scattered%20on%20warm%20desk%20with%20soft%20light%2C%20editorial%20nostalgia%20abstract&width=800&height=520&seq=g12&orientation=landscape",
  },
  {
    id: "g13",
    title: "综艺嘉宾临时下车：录制冲突还是档期原因",
    category: "综艺现场",
    tag: "求证",
    heat: 566,
    date: "2026.08.14",
    read: "7 分钟",
    excerpt:
      "临录前嘉宾下车的消息一出，粉丝与节目组各执一词。我们从通告排期、现场花絮到官方口径逐条比对，梳理事件的可信线索。",
    image:
      "https://readdy.ai/api/search-image?query=empty%20variety%20show%20host%20seats%20on%20stage%20under%20warm%20theater%20light%2C%20editorial%20cinematic%20abstract&width=800&height=520&seq=g13&orientation=landscape",
  },
  {
    id: "g14",
    title: "新茶饮品牌同款风波：谁在蹭谁的热度",
    category: "商界风云",
    tag: "对比",
    heat: 542,
    date: "2026.08.12",
    read: "9 分钟",
    excerpt:
      "两杯几乎撞款的爆品先后上线，网友为谁先推出吵翻天。我们从产品上线时间、包装细节到营销节奏逐项对比，还原撞款风波始末。",
    image:
      "https://readdy.ai/api/search-image?query=two%20iced%20drinks%20cups%20side%20by%20side%20on%20pastel%20cream%20background%20with%20warm%20natural%20light%2C%20editorial%20food%20minimal%20abstract&width=800&height=520&seq=g14&orientation=landscape",
  },
];

export interface TimelineNode {
  date: string;
  time: string;
  title: string;
  desc: string;
  source: string;
}

export interface DeepEvent {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  summary: string;
  nodes: TimelineNode[];
}

export const deepEvent: DeepEvent = {
  id: "deep-1",
  title: "年度最大瓜：顶流演员片约风波完整时间线",
  subtitle: "从营销号首曝到全员回应，87 天事件全记录 · 一份看透全过程的完整档案",
  cover:
    "https://readdy.ai/api/search-image?query=large%20theatrical%20stage%20curtain%20parting%20with%20golden%20warm%20light%20beam%20and%20scattered%20film%20slate%2C%20cinematic%20editorial%20hero%20dramatic&width=1200&height=640&seq=deephero&orientation=landscape",
  summary:
    "一场从一张合同截图开始的片约争议，在 87 天里演变成牵动投资方、播出平台、经纪公司与多方粉丝的年度焦点。我们以信源标签、时间排序与语境补充的方式，把散落在各平台的关键节点归档成一条完整时间线，适合想一次性吃透整件事的读者。",
  nodes: [
    {
      date: "06月10日",
      time: "11:24",
      title: "营销号首曝：一张合同截图流出",
      desc: "某娱乐博主放出疑似合同截图，称主演因剧本改动提出调整档期，随后多个营销号跟进转发，话题词冲上热搜。此时截图真伪尚无官方印证，信源等级较低。",
      source: "信源：自媒体 · 待核实",
    },
    {
      date: "06月12日",
      time: "19:40",
      title: "片方深夜发声：措辞引发解读",
      desc: "剧方发布公告，使用充分沟通、友好协商等表述，未直接否认截图内容，被网友解读为默认，舆论出现第一轮分化。",
      source: "信源：片方声明 · 官方",
    },
    {
      date: "06月18日",
      time: "10:02",
      title: "经纪团队首次回应，点名平台方",
      desc: "经纪团队发布长文，将矛头指向播出平台排播方案，称档期冲突源于平台档期调整而非演员态度问题，事件从片约延展到平台排播。",
      source: "信源：经纪团队 · 官方",
    },
    {
      date: "06月25日",
      time: "15:17",
      title: "平台方晒出排期表，暗藏信息量",
      desc: "播出平台晒出盖章排期表与往来邮件节选，指出剧集上线日期早已确定。网友从表中日期倒推，发现双方口径存在明显出入。",
      source: "信源：平台方 · 官方",
    },
    {
      date: "07月03日",
      time: "13:55",
      title: "投资方信源爆料：二次增资与进度",
      desc: "有投资相关信源透露项目中途曾追加投资，暗示拍摄进度受影响。该说法未获官方确认，被标记为行业传闻。",
      source: "信源：行业传闻 · 待核实",
    },
    {
      date: "07月14日",
      time: "08:30",
      title: "主演方晒剧组通告，现场照流出",
      desc: "主演团队晒出多张现场通告与片场照，意在证明拍摄正常推进，引发粉丝与片方阵营新一轮博弈，热度达到峰值。",
      source: "信源：主演团队 · 官方",
    },
    {
      date: "08月02日",
      time: "21:08",
      title: "平台方与片方联合声明：定档 9 月",
      desc: "三方联合发布声明，宣布剧集于 9 月上线，措辞首次趋于一致。舆论从撕扯转向和解复盘，争议进入收尾阶段。",
      source: "信源：联合声明 · 官方",
    },
    {
      date: "09月05日",
      time: "18:00",
      title: "完整复盘上线：吃瓜大全建档完成",
      desc: "事件热度退潮后，我们整理全部信源、口径与时间节点，补齐语境与反转过程，形成这份可随时回看的完整存档。",
      source: "信源：吃瓜大全整理",
    },
  ],
};

export const faqs = [
  {
    q: "吃瓜大全的完整存档和普通热搜有什么不同？",
    a: "普通热搜只呈现事件爆发的瞬间，而吃瓜大全会把一条事件从首曝、发酵、多方回应到收尾的完整过程按时间归档。你可以在一个页面里看到事情的源头、关键转折与后续进展，无需在不同平台反复翻找，适合想一次吃透整件事的读者。",
  },
  {
    q: "资料库里的事件会一直更新吗？",
    a: "会。每条已建档事件都会持续跟进，当出现新的关键节点时，我们会追加到对应的时间线里并标注更新时间。资料库本身也会随热搜随时扩充新的事件，你可以常回来看是否有更新。",
  },
  {
    q: "你们的内容可靠吗？会不会是带节奏的爆料？",
    a: "吃瓜大全坚持可溯源、可对比、不预判的三条内容原则。我们为每一条信息标注信源等级（官方声明、当事方口径、行业传闻、待核实），并尽量补充事件语境，让你能看到完整信息而非单方面说法，从而自己做出判断。",
  },
  {
    q: "事件里的深度爆料部分是从哪里来的？",
    a: "深度爆料以多方公开信源（声明、公告、通告、公开记录）交叉整理为主，少数行业传闻会明确标注为待核实并说明出处语境。我们不会把未经证实的传闻写成既定事实，也会在重大反转时及时更新并修正先前归档。",
  },
  {
    q: "一个瓜要从哪里开始看才能最快看懂？",
    a: "建议先看对应事件的一句话摘要，再顺着时间线看前三个关键节点了解起因，之后按兴趣跳到中间的反转节点。我们为每条事件都做了分级目录，新手也能快速上手，不必从头追到尾。",
  },
  {
    q: "我追的一个瓜不在资料库里，能帮忙建档吗？",
    a: "欢迎在页脚联系入口提交你关注的事件。我们会在评估事件具备足够的公开信源与讨论量后，安排整理并加入资料库。热门且信源充足的事件会被优先建档。",
  },
];

export const values = [
  {
    icon: "ri-time-line",
    title: "先溯源，再发声",
    desc: "坚持信源优先，把谁说的、在哪说的、什么时候说的都标注清楚，让信息有来处。",
  },
  {
    icon: "ri-git-branch-line",
    title: "完整胜过热闹",
    desc: "不追单点爆点，更看重把一件事情的来龙去脉按时间串完整，让读者一次吃透。",
  },
  {
    icon: "ri-scales-3-line",
    title: "呈现而非预判",
    desc: "尽量呈现多方口径与语境，把判断权交给读者，不在标题和正文里替你下结论。",
  },
  {
    icon: "ri-refresh-line",
    title: "跟到收尾不止步",
    desc: "热度过后的反转与收尾同样重要，我们会持续更新档案直到事件尘埃落定。",
  },
];

export const stats = [
  { num: "1280+", label: "已建档事件" },
  { num: "96%", label: "带官方信源标注" },
  { num: "24h", label: "热点跟进响应" },
  { num: "6", label: "大类目持续扩容" },
];